document.addEventListener('DOMContentLoaded', function () {

 
    document.querySelectorAll('.custom-splide').forEach((splideEl) => {
  if (!splideEl.classList.contains('splide-initialized')) {
    new Splide(splideEl, {
      type: 'slide',
      perPage: 3,
      gap: '30px',
      arrows: false,
      pagination: true,
      breakpoints: {
        1024: { 
          perPage: 3,
          gap: '15px',
        },
        768: { 
          perPage: 2,
          gap: '15px',
        },
        480: { 
          perPage: 1
        }
      }
    }).mount();
    splideEl.classList.add('splide-initialized');
  }
});


  
  const colltwoEl = document.querySelector('#custom_featuredSlide2');

  if (colltwoEl && !colltwoEl.classList.contains('splide-initialized')) {
    const colltwo = new Splide(colltwoEl, {
      type: 'slide', 
      perPage: 4,
      arrows: false,
      pagination: true,
      gap: '30px',
      autoWidth: false,
        breakpoints: {
          1024: { 
            perPage: 3,
            gap: '15px',
          },
          768: { 
            perPage: 2,
            gap: '15px',
          },
          480: { 
            perPage: 1
          }
        }
    });

    colltwo.mount();
    colltwoEl.classList.add('splide-initialized');
  }
}); // document end
